<script>
  // import image from "img/magellan.png"
  export let open;
  let move = false
  let count = 0
  let show = false
  

  let intervalId = setInterval(function () {
    count++
    move = !move
    if (count >= 6) {
        clearInterval(intervalId);
    } 
  }, 2000);

  const onClick = () => {
    show=false
    clearInterval(intervalId);
    open = true;
	}

  const enter =(e)=>{
    setTimeout(()=>{
      show = true
    },200)
  }

  const exit =(e)=>{
    show = false
  }

</script>



<div class="fixed bottom-3 right-3 cursor-pointer pop" class:active={move} on:mouseenter={enter} on:mouseleave={exit}>
  <div class="relative">
    {#if show}
      <div class="absolute bottom-full left-0 bg-gray-100 shadow-md p-4 rounded-lg">
        <div class="font-bold text-sm">Magellan | Your Eyeglass Assistant</div>
        <div class="text-xs">Find out more about our special offers</div>
      </div>
    {/if}
    <img src="img/magellan.png" alt="magellan" on:click={onClick}/>
  </div>
</div>

<style>
	.pop {
		animation-duration: 1.5s;
		animation-play-state: paused;
		animation-fill-mode: forwards;
    animation-timing-function: ease-in-out;
	}
	.pop.active {
		animation-name: wiggle;
		animation-play-state: running;
	}
	
	@keyframes wiggle {
	
    30%{
      transform: translateY(-45px);
    }
    35%{
      transform: translateY(-45px);
    }
		60% {
			transform: translateY(0px);
		}
		80% {
			transform: translateY(-30px);
		}
		100% {
			transform: translateY(0px);
		}
	}
</style>
